import { useQuery, useQueryClient } from "react-query";

export const MODAL_QUERY_NM = 'MODAL_INFO';
export const useGetModalInfo = () => {
    return useQuery([MODAL_QUERY_NM],()=>undefined,{initialData:{show:false,msg:''}});
}